import { Loader } from "@circle-react-uikit/Loader";
import type { BillingInfoContextProps } from "../BillingInfoContextProps";
import { BillingInfoFormProvider } from "../BillingInfoFormProvider";
import { useBillingInfoQuery } from "../useBillingInfoQuery";
import { BillingInfoModalFormContent } from "./BillingInfoModalFormContent";

export interface BillingInfoModalFormWrapperProps
  extends Omit<BillingInfoContextProps, "communityMemberBillingInfo"> {}

export const BillingInfoModalFormWrapper = ({
  communityMember,
  ...props
}: BillingInfoModalFormWrapperProps) => {
  const { isLoadingBillingInfo, billingInfo } =
    useBillingInfoQuery(communityMember);

  if (isLoadingBillingInfo) {
    return <Loader variant="default" />;
  }

  return (
    <BillingInfoFormProvider
      {...props}
      communityMember={communityMember}
      communityMemberBillingInfo={billingInfo ?? {}}
    >
      <BillingInfoModalFormContent />
    </BillingInfoFormProvider>
  );
};
